import { createAction } from 'redux-actions';

const actions = {
  /**
   *  [상품 후기 상세] 태그 리스트 전체 엑셀 다운로드
   */
  GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST:
    'cs/review/GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  getReviewDetailTagAllListExcelDownload: createAction(
    'cs/review/GET_REVIEW_DETAIL_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),
  /**
   *  [상품 후기 상세] 태그 리스트 선택 엑셀 다운로드
   */
  GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST:
    'cs/review/GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  getReviewDetailTagSelectedListExcelDownload: createAction(
    'cs/review/GET_REVIEW_DETAIL_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),
  /**
   *  [상품 후기 상세] 태그 리스트 요청하기
   */
  GET_REVIEW_DETAIL_TAG_LIST_REQUEST: 'cs/review/GET_REVIEW_DETAIL_TAG_LIST_REQUEST',
  GET_REVIEW_DETAIL_TAG_LIST_SUCCESS: 'cs/review/GET_REVIEW_DETAIL_TAG_LIST_SUCCESS',
  getReviewDetailTagList: createAction('cs/review/GET_REVIEW_DETAIL_TAG_LIST_REQUEST'),
};

export default actions;
